import { combineReducers } from 'redux';
import arrangements from './arrangementsReducer';
import dimensions from './dimensionsReducer';
import configuration from './configurationReducer';
import products from './productsReducer';
import token from './tokenReducer';
import accessories from './accessoriesReducer';
import addons from './addonsReducer';
import socialShare from './socialShareReducer';
import productTypes from './productTypesReducer';
import defaults from './defaultsReducer.js';

const rootReducer = combineReducers({
  arrangements: arrangements,
  dimensions: dimensions,
  products: products,
  token: token,
  accessories: accessories,
  addons: addons,
  productTypes: productTypes,
  configuration: configuration,
  defaults: defaults,
  socialShare: socialShare,
});

export default rootReducer;
